export type Categoria = 'torte' | 'crostate' | 'cupcakes';

export type Creazione = {
  src: string;
  alt: string;
  categoria: Categoria;
};

/** Foto reali dal profilo Instagram @racheledolcezze (galleria su ordinazione). */
export const creazioni: Creazione[] = [
  { src: '/images/gallery/rose-rosse.jpg', alt: 'Torta con rose rosse', categoria: 'torte' },
  { src: '/images/gallery/torta-frutti-rossi.jpg', alt: 'Torta ai frutti rossi', categoria: 'torte' },
  { src: '/images/gallery/drip-cioccolato.jpg', alt: 'Drip cake al cioccolato', categoria: 'torte' },
  { src: '/images/gallery/ghirlanda-fragole.jpg', alt: 'Torta a ghirlanda con fragole', categoria: 'torte' },
  { src: '/images/gallery/crema-frutta.jpg', alt: 'Torta crema e frutta', categoria: 'torte' },
  { src: '/images/gallery/blu-oro.jpg', alt: 'Torta blu e oro', categoria: 'torte' },
  { src: '/images/gallery/crostata-cioccolato.jpg', alt: 'Crostata al cioccolato e frutti', categoria: 'crostate' },
  { src: '/images/gallery/crostata-frutti-rossi.jpg', alt: 'Crostata ai frutti rossi', categoria: 'crostate' },
  { src: '/images/gallery/crostata-pesche.jpg', alt: 'Crostata alle pesche', categoria: 'crostate' },
  { src: '/images/gallery/crostata-frutta.jpg', alt: 'Crostata alla frutta', categoria: 'crostate' },
  { src: '/images/gallery/cupcakes-mirtilli.jpg', alt: 'Cupcakes ai mirtilli', categoria: 'cupcakes' },
  { src: '/images/gallery/cupcakes-fragola.jpg', alt: 'Cupcakes alla fragola', categoria: 'cupcakes' },
  { src: '/images/gallery/cupcakes-crema.jpg', alt: 'Cupcakes alla crema', categoria: 'cupcakes' },
];

export const categorie: { key: Categoria; label: string }[] = [
  { key: 'torte', label: 'Torte' },
  { key: 'crostate', label: 'Crostate' },
  { key: 'cupcakes', label: 'Cupcakes' },
];

/** Dolci pronti in vetrina (passa e compra, senza ordinare). */
export const pronti: { src: string; alt: string }[] = [
  { src: '/images/pronti/muffin.jpg', alt: 'Muffin' },
  { src: '/images/pronti/bigne.jpg', alt: 'Bignè' },
  { src: '/images/pronti/crostatine.jpg', alt: 'Crostatine' },
  { src: '/images/pronti/tartellette.jpg', alt: 'Tartellette al cioccolato' },
  { src: '/images/pronti/girella.jpg', alt: 'Girella al cioccolato' },
];

export const pasticceria = {
  nome: 'Rachele Dolcezze',
  citta: 'Travedona Monate',
  indirizzo: 'Travedona Monate (VA)',
  aperturaDal: 'maggio 2026',
  whatsapp: 'https://wa.me/39', // PLACEHOLDER — numero reale di Rachele
  instagram: 'https://www.instagram.com/racheledolcezze/',
  ordinaImg: '/images/negozio/torta-ordinazione.jpg',
  laboratorio: '/images/negozio/laboratorio.jpg',
};

/** Tutte le foto della galleria, per il lightbox. */
export const tutteLeFoto = creazioni.map((c) => c.src);
